type RedirectRule = {
  from: string;
  field: string;
  value: string;
  to: string;
};

/**
 * Static, code-level redirects. Empty for the hairstyle funnels — they branch
 * through dynamicRedirectRules in remote config instead.
 */
export const REDIRECT_RULES: RedirectRule[] = [];
